import { useState } from "react";
import { cadastrarAssinaturasService } from "../../../services/cadastrarAssinaturasService";
import { Assinatura } from "../../../interfaces/Assinatura";
import { buscarAssinaturaAtivaByCotaUsuarioIdService } from "../../../services/buscarAssinaturaAtivaByCotaUsuarioIdService";

export const useAssinatura = () => {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (
    assinaturaData: Partial<Assinatura>
  ): Promise<boolean> => {
    setIsLoading(true);

    const verificarAssinatura = await verificarAssinaturaExistente(
      assinaturaData.cotasUsuariosId!
    );

    if (verificarAssinatura) {
      setError("Já existe uma assinatura ativa para esta cota de usuário.");
      setIsLoading(false);
      return false;
    }

    try {
      const dataAssinatura: Partial<Assinatura> = {
        usuarioId: assinaturaData.usuarioId,
        planoAssinatura: "ANUNCIO_PROPRIEDADE",
        cotasUsuariosId: assinaturaData.cotasUsuariosId,
        active: 1,
        dataAssinatura: assinaturaData.dataAssinatura,
        dataVencimento: assinaturaData.dataVencimento,
        status: "PENDENTE",
      };
      console.log(dataAssinatura);
      const data = await cadastrarAssinaturasService(dataAssinatura);

      if (data) {
        setSuccess("Assinatura cadastrada com sucesso!");
        return true;
      } else {
        setError(
          "Não foi possível cadastrar assinatura, por favor tente novamente!"
        );
        return false;
      }
    } catch (error) {
      setError(
        "Não foi possível cadastrar assinatura, por favor tente novamente!"
      );
      return false; // garante que sempre retorna boolean
    } finally {
      setIsLoading(false);
    }
  };

  const verificarAssinaturaExistente = async (
    usuarioId: number
  ): Promise<boolean> => {
    setIsLoading(true);
    try {
      const response = await buscarAssinaturaAtivaByCotaUsuarioIdService(
        usuarioId
      );
      return response;
    } catch (error) {
      setError("Erro ao verificar assinatura existente.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { cadastrar, success, error, isLoading, resetError, resetSuccess };
};
